import { useTranslation } from "react-i18next";
import uz from "../locales/uz/finance.json";
import ru from "../locales/ru/finance.json";
export function useFinanceText() {
  const { i18n } = useTranslation();
  const words: Record<string, string> = i18n.language === "ru" ? ru : uz;
  return (key: string) => words[key] ?? key;
}
export const financeToday = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Tashkent", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
